import { render, staticRenderFns } from "./RrcvN_Items_List.vue?vue&type=template&id=20ae7c86"
import script from "./RrcvN_Items_List.vue?vue&type=script&lang=js"
export * from "./RrcvN_Items_List.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports